import { Controller } from "@hotwired/stimulus"

// Copies a block of text to the clipboard and confirms it on the button itself.
//
// Used by the video review page so a recreate pack — the @-tag header plus the
// prompt that produced a clip — can be lifted straight into Artlist without
// selecting several hundred lines by hand.
//
//   %div{ data: { controller: "copy-text" } }
//     %pre{ data: { "copy-text-target": "source" } }= pack
//     %button{ data: { action: "copy-text#copy" } } Copy
export default class extends Controller {
  static targets = ["source", "button"]

  async copy(event) {
    event.preventDefault()
    const button = this.hasButtonTarget ? this.buttonTarget : event.currentTarget
    const original = button.textContent

    try {
      await navigator.clipboard.writeText(this.sourceTarget.innerText)
      button.textContent = "Copied"
    } catch {
      // Clipboard access needs a secure context and can be refused outright.
      // Select the text instead so the copy is still one keystroke away.
      this.selectSource()
      button.textContent = "Press ⌘C"
    }

    setTimeout(() => { button.textContent = original }, 2000)
  }

  selectSource() {
    const range = document.createRange()
    range.selectNodeContents(this.sourceTarget)
    const selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
  }
}
